import { render, staticRenderFns } from "./OmxPermissionButton.vue?vue&type=template&id=1e80af4e&scoped=true"
import script from "./OmxPermissionButton.vue?vue&type=script&lang=js"
export * from "./OmxPermissionButton.vue?vue&type=script&lang=js"
import style0 from "./OmxPermissionButton.vue?vue&type=style&index=0&id=1e80af4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e80af4e",
  null
  
)

export default component.exports